var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header',{on:{"onScroll":_vm.scrollTo}}),_c('Banner'),_c('Introduce',{ref:"introduce",on:{"onScroll":_vm.scrollTo}}),_c('Images'),_c('News',{ref:"news"}),_c('Form',{ref:"form"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }